<template>
    <div class="container">
      <header-com/>
      <h1 class="f56">填写快递单号</h1>
      <ul>
        <li class="f32" @click='expressShow = true'>
          <span>{{platform.expressPlatformName?platform.expressPlatformName:'请选择快递公司'}}</span>
        </li>
        <li class="f32" v-for="(item, index) in expressList" :key="index">
          <input type="text" placeholder="请输入快递单号" v-model="item.code" @blur='inputBlur'/>
        </li>
        <li class="add f32" @click="add">
          <span>添加快递单号</span>
        </li>
      </ul> 

      <button class='fullbtn' :class='{disable:!disabel}' @click="submitExpress">提交</button>

      <van-popup v-model="expressShow" style='width:300px;'>
        <van-picker 
        :columns="columns" 
        show-toolbar
        @cancel="expressShow = false"
        @confirm="onConfirm"
        toolbar-position='bottom'
        />

      </van-popup>

    </div>
</template>

<script>
  import orderApi from '@/axios/order'
  import { Toast } from 'vant';
  import { setTimeout } from 'timers';
  import zhugeObj from '@/assets/js/track';
  import publicObj from '@/assets/js/public';
  export default {
    name: 'index',
    data () {
      return {
        tid : '',
        platform : {},
        columns: [],
        expressPlatformList : [],
        expressShow : false,
        expressList: [
          {
            code: ''
          }
        ]
      }
    },
    created () {
      this.tid = this.$route.query.id;
      this.getExpressList();
    },
    computed: {
      // 计算属性的 getter
      disabel : function() {
        // `this` 指向 vm 实例
        let tab = false;
        this.expressList.forEach(element=>{
          if(element.code){
            tab = true;
          }
        })
        if(JSON.stringify(this.platform) != '{}' && tab){
          return true;
        }else{
          return false;
        }
      }
    },
    methods: {
      inputBlur(){
        publicObj.IPhoneXHack()
      },
      submitExpress(){
        let _this = this;
        let params = {
          bookingsOrderId : this.tid,
          expressPlatformId : this.platform.id,
          expressCodeList : []
        }
        params.expressCodeList = this.expressList.filter(item => item.code != '').map((element)=>{return element.code})

        orderApi.addPackage(params).then((res)=>{
          Toast('添加成功');
          zhugeObj.track({
            title : '预约-点击填写快递单号',
            content : {
              '预约单ID' : this.tid,
              '快递平台' : this.platform.id,
              '快递单号' : params.expressCodeList.join(',')
            }
          })
          setTimeout(()=>{
            _this.$router.back()
          },500)
          
        })
      },
      getExpressList(){
        orderApi.getExpressPlatform({}).then((res)=>{
          this.expressPlatformList = res;
          res.forEach(element => {
            this.columns.push(element.expressPlatformName)
          });
        })
      },
      onConfirm(value, index){
          this.platform = this.expressPlatformList[index];
          this.expressShow = false;
      },
      add () {
        this.expressList.push({
          code: ''
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  .container{
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding-top: 116px;
    padding-bottom:150px;
    h1{
      width: 690px;
      line-height: 80px;
      font-weight: 500;
    }
    ul{
      width: 690px;
      margin-top: 50px;
      li{
        width:690px;
        height:92px;
        border-radius:60px;
        border:1px solid rgba(51,51,51,1);
        font-weight:400;
        text-align: center;
        line-height: 92px;
        margin-bottom: 80px;
        input{
          width: 100%;
          text-align: center;
          &::placeholder{
            font-size:32px;
            color: #333;
          }
        }
        &.add{
          border:1px dashed rgba(153,153,153,1);
          color: rgba(153,153,153,1);
        }
        &:last-child{
          margin: 0;
        }
      }
    }
  }

  .disable{
    background: #CCCCCC!important;
  }

  .fullbtn{
    background: #333333;
    color:#fff;
    font-size:32px; 
    height: 92px;
    width:690px;
    border-radius:46px; 
    position: fixed;
    bottom:20px;

  }
</style>

